export enum CheckoutErrorLogKeys {
  PAYMENTS_BUTTONS_JS = 'PAYMENTS_BUTTONS_ERROR',
  PAYMENTS_PAYMENT_JS = 'PAYMENTS_PAYMENT_ERROR',
  checkoutContainer = 'CHECKOUT_CONTAINER',
  checkoutService = 'CHECKOUT_SERVICE_ERROR',
  confirmationPage = 'CHECKOUT_CONFIRMATION_PAGE_ERROR',
  deliveryGroup = 'CHECKOUT_DELIVERY_GROUP_ERROR',
  deliveryOptions = 'CHECKOUT_DELIVERY_OPTIONS_ERROR',
  giftCardForm = 'CHECKOUT_GIFT_CARD_FORM',
  gifting = 'SPC_GIFTING',
  httpInterceptor = 'CHECKOUT_HTTP_INTERCEPTOR_ERROR',
  identityId = 'CHECKOUT_JWT_IDENTITYID_ERROR',
  marketingSmsUpdates = 'CHECKOUT_MARKETING_SMS_UPDATE_ERROR',
  orderSummary = 'CHECKOUT_ORDER_SUMMARY_ERROR',
  paygateForm = 'CHECKOUT_PAYGATE_FORM_ERROR',
  payments = 'CHECKOUT_PAYMENTS_ERROR',
  paypal = 'CHECKOUT_PAYPAL_ERROR',
  pickYourPointsDay = 'LOYALTY_PYPD_RETRIEVAL_ERROR',
  resolveGuard = 'CHECKOUT_RESOLVE_GUARD_ERROR',
  rewardsCardForm = 'CHECKOUT_REWARDS_CARD_FORM',
  sameDayTip = 'CHECKOUT_SAME_DAY_TIPPING_ERROR',
  singlePage = 'SINGLE_PAGE_CHECKOUT',
  singlePageBilling = 'SPC_BILLING_ADDRESS_ERROR',
  singlePageContact = 'SPC_CONTACT_INFO_ERROR',
  singlePagePayments = 'SPC_PAYMENTS_ERROR',
  singlePageResolveGuard = 'CHECKOUT_SINGLE_PAGE_RESOLVE_GUARD_ERROR',
  singlePageSavedAddresses = 'SPC_SAVED_ADDRESSES',
  singlePageShipping = 'SPC_SHIPPING_ADDRESS_ERROR',
  smsUpdates = 'CHECKOUT_SMS_UPDATE_ERROR',
}
